var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.001 2.81919C14.8197 0.309711 19.1756 0.393022 21.8907 3.09153C24.6059 5.79004 24.6991 10.0892 22.1739 12.8932L11.9997 23L1.82562 12.8932C-0.699529 10.0892 -0.605139 5.78324 2.10879 3.09153C4.82579 0.396771 9.17405 0.305986 12.001 2.81919ZM20.192 4.77291C18.3931 2.98511 15.4888 2.91259 13.6041 4.59054L12.0021 6.01679L10.3991 4.59166C8.50901 2.91135 5.60996 2.98527 3.80581 4.77466C2.01816 6.54768 1.92841 9.38737 3.57585 11.2629L11.9997 19.631L20.4237 11.2629C22.0718 9.38666 21.9824 6.55237 20.192 4.77291Z",
    fill: "#229986"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIconGreen);
export default __webpack_public_path__ + "static/media/Love_icon_green.f734921cc7dad8da0e9dd66ff9ff69ae.svg";
export { ForwardRef as ReactComponent };